<p-toast></p-toast>
<div class="card p-4 surface-card border-round-md shadow-2">
    <h2 class="mb-3">Promo Plans List</h2>
    <p-toolbar styleClass="mb-4">
        <div class="p-toolbar-group-start">
            <p-button label="New Promo Plan" icon="pi pi-plus" styleClass="p-button-success"
                (click)="uploadPromoPlan()"></p-button>
        </div>
        <div class="p-toolbar-group-end">
            <p-button label="Export to Excel" icon="pi pi-file-excel" styleClass="p-button-help" (click)="exportExcel()"
                [loading]="isExporting"></p-button>
        </div>
    </p-toolbar>

    <div class="card p-4 surface-card border-round-md shadow-2 mb-4">
        <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
            <div class="grid formgrid p-fluid">
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText type="number" formControlName="id" id="id" class="w-full">
                            <label for="id">Promo Plan ID</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-pencil"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="promoDescription" id="promoDescription" class="w-full">
                            <label for="promoDescription">Description</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <app-entity-dropdown-multiselect-picker
                    formControlName="promoTypes"
                    [adapter]="promoTypePickerAdapter"
                    inputId="activityType"
                    label="Activity Type"
                    placeholder="Select activity types"
                    filterPlaceholder="Filter activity types"
                    addonIconClass="pi pi-bolt"
                    columnClass="col-12 md:col-6 lg:col-4"
                    [searchPageSize]="25"
                    [searchMinLength]="0"
                ></app-entity-dropdown-multiselect-picker>
                <app-entity-dropdown-multiselect-picker
                    formControlName="customers"
                    [adapter]="customerPickerAdapter"
                    inputId="customer"
                    label="Customer"
                    placeholder="Select customers"
                    filterPlaceholder="Filter customers"
                    addonIconClass="pi pi-users"
                    columnClass="col-12 md:col-8 lg:col-8"
                    [searchPageSize]="25"
                    [searchMinLength]="0"
                ></app-entity-dropdown-multiselect-picker>
                <app-entity-dropdown-multiselect-picker
                    formControlName="brands"
                    [adapter]="brandPickerAdapter"
                    inputId="brand"
                    label="Brand"
                    placeholder="Select brands"
                    filterPlaceholder="Filter brands"
                    addonIconClass="pi pi-tag"
                    columnClass="col-12 md:col-4 lg:col-4"
                    [searchPageSize]="25"
                    [searchMinLength]="0"
                ></app-entity-dropdown-multiselect-picker>
                <app-entity-dropdown-multiselect-picker
                    formControlName="subBrands"
                    [adapter]="subBrandPickerAdapter"
                    inputId="subBrand"
                    label="Sub-Brand"
                    placeholder="Select sub-brands"
                    filterPlaceholder="Filter sub-brands"
                    addonIconClass="pi pi-tag"
                    columnClass="col-12 md:col-4 lg:col-4"
                    [searchPageSize]="25"
                    [searchMinLength]="0"
                ></app-entity-dropdown-multiselect-picker>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-map-marker"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="cities" id="city" class="w-full">
                            <label for="city">City</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-percentage"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText type="number" formControlName="discountPercentage" id="discountPercentage"
                                class="w-full">
                            <label for="discountPercentage">Discount %</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-check-square"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-multiSelect formControlName="statuses" [options]="statusOptions" inputId="status"
                                styleClass="w-full" [showClear]="true" display="chip" [filter]="false">
                            </p-multiSelect>
                            <label for="status">Status</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-globe"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="channels" id="channel" class="w-full">
                            <label for="channel">Channel</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="batchNumbers" id="batchNumber" class="w-full">
                            <label for="batchNumber">Batch #</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>

                <div class="field col-12 md:col-6 lg:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="startDateFrom" dateFormat="yy-mm-dd" inputId="startDateFrom"
                                [showIcon]="true" [style]="{'width': '100%'}" class="w-full"></p-calendar>
                            <label for="startDateFrom">Start Date</label>
                        </p-iftalabel>
                        <p-dropdown [options]="startDateOptions" formControlName="startDateOption"
                            inputId="startDateOption" [style]="{'width': '250px'}" [showClear]="true"></p-dropdown>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-6"
                    *ngIf="filterForm.get('startDateOption')?.getRawValue() === 'is between'">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="startDateTo" dateFormat="yy-mm-dd" inputId="startDateTo"
                                [showIcon]="true" [style]="{'width': '100%'}" class="w-full"></p-calendar>
                            <label for="startDateTo">Start Date To</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-6"
                    *ngIf="filterForm.get('endDateOption')?.getRawValue() === 'is between'">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="endDateFrom" dateFormat="yy-mm-dd" inputId="endDateFrom"
                                [showIcon]="true" [style]="{'width': '100%'}" class="w-full"></p-calendar>
                            <label for="endDateFrom">End Date From</label>
                        </p-iftalabel>
                        <p-dropdown [options]="endDateOptions" formControlName="endDateOption" inputId="endDateOption"
                            [style]="{'width': '250px'}" [showClear]="true"></p-dropdown>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="endDateTo" dateFormat="yy-mm-dd" inputId="endDateTo"
                                [showIcon]="true" [style]="{'width': '100%'}" class="w-full"></p-calendar>
                            <label for="endDateTo">End Date</label>
                        </p-iftalabel>
                        <p-dropdown [options]="endDateOptions" formControlName="endDateOption" inputId="endDateOption"
                            [style]="{'width': '250px'}" [showClear]="true"></p-dropdown>
                    </p-inputgroup>
                </div>
            </div>
            <div class="flex justify-content-end gap-2 mt-4">
                <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary"
                    (click)="onReset()"></p-button>
                <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
            </div>
        </form>
    </div>

    <p-table #dt [value]="promoPlans" [loading]="isLoading" dataKey="promoPlanId" [paginator]="true" [rows]="25"
        [totalRecords]="totalRecords" [paginatorDropdownAppendTo]="'body'"
        [rowsPerPageOptions]="[25, 50, 100, 200, 500]" styleClass="p-datatable-striped" responsiveLayout="scroll"
        [lazy]="true" (onLazyLoad)="loadPromoPlans($event)" [autoLayout]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 8rem">Actions</th>
                <th pSortableColumn="promoPlanHeader.promoPlanId">
                    ID <p-sortIcon field="promoPlanHeader.promoPlanId"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.promoDescription">
                    Description <p-sortIcon field="promoPlanHeader.promoDescription"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.customer.customerNumber">
                    Customer # <p-sortIcon field="promoPlanHeader.customer.customerNumber"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.customer.customerName">
                    Customer Name<p-sortIcon field="promoPlanHeader.customer.customerName"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.channel">
                    Channel <p-sortIcon field="promoPlanHeader.channel"></p-sortIcon>
                </th>
                <th pSortableColumn="tamerItem.erpItemNumber">
                    Tamer Item <p-sortIcon field="tamerItem.erpItemNumber"></p-sortIcon>
                </th>
                <th pSortableColumn="brand.brandName">
                    Brand <p-sortIcon field="brand.brandName"></p-sortIcon>
                </th>
                <th pSortableColumn="subBrand.subBrandName">
                    Sub-Brand <p-sortIcon field="subBrand.subBrandName"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.city">
                    City <p-sortIcon field="promoPlanHeader.city"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.discountPercentage">
                    Discount % <p-sortIcon field="promoPlanHeader.discountPercentage"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.status">
                    Status <p-sortIcon field="promoPlanHeader.status"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.batchNumber">
                    Batch # <p-sortIcon field="promoPlanHeader.batchNumber"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.promoType">
                    Type <p-sortIcon field="promoPlanHeader.promoType"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.promoStartDate" [style]="{'width':'12rem'}">
                    Start Date <p-sortIcon field="promoPlanHeader.promoStartDate"></p-sortIcon>
                </th>
                <th pSortableColumn="promoPlanHeader.promoEndDate" [style]="{'width':'12rem'}">
                    End Date <p-sortIcon field="promoPlanHeader.promoEndDate"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-promo>
            <tr style="white-space: nowrap;">
                <td>
                    <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-info"
                        (click)="viewPromoPlan(promo.promoPlanHeader.promoPlanId)"></button>
                </td>
                <td>{{ promo.promoPlanHeader.promoPlanId }}</td>
                <td>{{ promo.promoPlanHeader.promoDescription }}</td>
                <td>{{ promo.promoPlanHeader?.customer?.customerNumber }}</td>
                <td>{{ promo.promoPlanHeader.customer.customerName }}</td>
                <td>{{ promo.promoPlanHeader.channel }}</td>
                <td>{{ promo.tamerItem?.erpItemNumber }} - {{ promo.tamerItem?.erpItemNameE }}</td>
                <td>{{ promo.brand?.brandName }}</td>
                <td>{{ promo.subBrand?.subBrandName }}</td>
                <td>{{ promo.promoPlanHeader?.city }}</td>
                <td>{{ promo.discountPercentage ? ((promo.discountPercentage * 100) + '%') : '' }}
                <td>{{ promo.promoPlanHeader?.statusName }}
                    <p-tag [value]="promo.promoPlanHeader?.workflowStatus?.statusName?.toUpperCase()"
                        [severity]="getStatusSeverity(promo)" [rounded]="true"></p-tag>
                </td>
                <td>{{ promo.promoPlanHeader?.batchNumber }}</td>
                <td><p-chip [icon]="promo.promoPlanHeader.activityType.icon"
                        [label]="promo.promoPlanHeader.activityType.name"></p-chip>
                </td>
                <td>{{ promo.promoPlanHeader.promoStartDate | date: 'dd-MMM-yyyy' }}</td>
                <td>{{ promo.promoPlanHeader.promoEndDate | date: 'dd-MMM-yyyy' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="13" class="text-center">No promo plans found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
